<template>
   <div>
       <input type="text" id="myInput" @keyup="myFunction()" placeholder="Rechercher ..." title="Type in a name">
       <div style="border: 1px solid #1E6E53; padding: 1%; text-align: center; display: none" id="not_found_text">
           Aucun élément trouvé
       </div>
   </div>
</template>

<script>
    import helpers from "../helpers/helpers";

    export default {
        name: "SearchInput",
        mixins: [helpers(this)],
        computed: {
            user() {
                return this.$store.getters['auth/loggedAs'];
            }
        },
    }
</script>

<style scoped>

</style>